// extracted by mini-css-extract-plugin
export default {"icon":"style_icon__p9Vq2","disabled":"style_disabled__IOrQO"};